module.exports = __webpack_public_path__ + "img/bg1.eb07f639.png";